import { yupResolver } from "@hookform/resolvers/yup";
import { useEffect } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";

import { getValidator } from "../../features/validatorSchema";
import {
  useFormContext,
  useSubmitForm,
  useUserAuthentication,
} from "../../hooks";
import { Router } from "../../router";
import { Url } from "../../router/enums";
import { routes } from "../../router/routes";
import { getPreviousRoute } from "../../router/utilities";
import { Errors } from "../Errors";
import { Header } from "../Header";
import { Footer } from "../Navigation/Footer";
import { Swipeable } from "../Swipeable";
import {
  selectFooterVisibility,
  selectRoutes,
  setErrorMessage,
} from "../formSettings.slice";

export const Provider = (): JSX.Element => {
  const { currentRoute: currentRouteFromStore } = useSelector(selectRoutes);
  const prevRoute = getPreviousRoute(currentRouteFromStore);
  const formContext = useFormContext();
  const isFooterVisible = useSelector(selectFooterVisibility);
  const methods = useForm({
    mode: "onBlur",
    resolver: yupResolver(getValidator(currentRouteFromStore)),
    context: formContext,
    shouldUnregister: true,
  });
  const dispatch = useDispatch();
  const onSubmitNextRouteSuccess = useSubmitForm(currentRouteFromStore);
  const onSubmitNextRouteInvalid = () =>
    dispatch(
      setErrorMessage("Uzupełnij wymagane pola zanim przejdziesz dalej")
    );
  const onSubmitPrevRouteSuccess = useSubmitForm(
    currentRouteFromStore,
    prevRoute
  );
  const onSubmitPrevRouteInvalid = () =>
    dispatch(setErrorMessage("Uzupełnij wymagane pola zanim powrócisz"));
  const isPrevPageAvailable =
    !!prevRoute &&
    prevRoute !== Url.OC_VEHICLE_SUMMARY &&
    prevRoute !== Url.AC_SUMMARY;

  useEffect(() => {
    if (methods.formState.isSubmitSuccessful) {
      methods.reset();
    }
  }, [methods]);
  useUserAuthentication();

  return (
    <FormProvider {...methods}>
      <Swipeable
        onSubmitNextRoute={methods.handleSubmit(
          onSubmitNextRouteSuccess,
          onSubmitNextRouteInvalid
        )}
        onSubmitPrevRoute={methods.handleSubmit(
          onSubmitPrevRouteSuccess,
          onSubmitPrevRouteInvalid
        )}
      >
        <Header />
        <Router routes={routes} />
        <Errors />
        <Footer
          currentRoute={currentRouteFromStore}
          isVisible={isFooterVisible}
          isPrevRouteAvailable={isPrevPageAvailable}
          onSubmitNextRoute={methods.handleSubmit(
            onSubmitNextRouteSuccess,
            onSubmitNextRouteInvalid
          )}
          onSubmitPrevRoute={methods.handleSubmit(
            onSubmitPrevRouteSuccess,
            onSubmitPrevRouteInvalid
          )}
        />
      </Swipeable>
    </FormProvider>
  );
};
